// e_ React pages
import CSup from "pages/Cours/Sup/Chimie/src";

export default function CSupPage() {
  return <CSup />;
}
